var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
/* eslint-disable no-empty-pattern */
import React, { useEffect, useState } from 'react';
import { Wrapper } from './ColumnButton.Styles';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { ViewColumn } from '@material-ui/icons';
import { Checkbox, FormControlLabel } from '@material-ui/core';
var ColumnButton = function (_a) {
    var columns = _a.columns, onVisibilityChange = _a.onVisibilityChange, values = _a.values;
    var _b = useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var _c = useState([]), visibleColumns = _c[0], setVisibleColumns = _c[1];
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
        onVisibilityChange(visibleColumns);
    };
    useEffect(function () {
        setVisibleColumns(values);
    }, [values]);
    var isChecked = function (column) {
        return !!visibleColumns.find(function (col) { return col === column; });
    };
    var onChangeColumnHidden = function (column, show) {
        var columnsList = __spreadArrays(visibleColumns);
        var selected = columnsList.find(function (c) { return c === column; });
        var index = selected && columnsList.indexOf(selected);
        if (show) {
            !selected && columnsList.push(column);
        }
        else {
            selected && columnsList.splice(index || 0, 1);
        }
        setVisibleColumns(columnsList);
    };
    return (React.createElement(Wrapper, null,
        React.createElement(IconButton, { "aria-label": 'more', "aria-controls": 'long-menu', "aria-haspopup": 'true', onClick: handleClick },
            React.createElement(ViewColumn, null)),
        React.createElement(Menu, { id: 'column-button-menu', anchorEl: anchorEl, keepMounted: true, open: Boolean(anchorEl), onClose: handleClose }, columns.map(function (col) { return (React.createElement(MenuItem, null,
            React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: isChecked(col.value), name: col.value, onChange: function (e) {
                        return onChangeColumnHidden(col.value, e.target.checked);
                    } }), label: col.label }))); }))));
};
ColumnButton.defaultProps = {
// bla: 'test',
};
export default React.memo(ColumnButton, function (oldProps, newProps) {
    return JSON.stringify(oldProps.values) === JSON.stringify(newProps.values) &&
        JSON.stringify(oldProps.columns) === JSON.stringify(newProps.columns);
});
//# sourceMappingURL=ColumnButton.js.map